var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTableDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  var unique = Math.random().toString(36).substring(2);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M1 0h16v16H1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.5 3h15a.5.5 0 110 1H.5a.5.5 0 010-1zM13 5a.5.5 0 01.5.5v9A1.5 1.5 0 0112 16H4a1.5 1.5 0 01-1.5-1.5v-9a.5.5 0 011 0v9a.5.5 0 00.5.5h8a.5.5 0 00.5-.5v-9A.5.5 0 0113 5zM5.5 0h5a.5.5 0 110 1h-5a.5.5 0 010-1z",
    fill: "#191C26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.25 7a.5.5 0 01.5.5v5a.5.5 0 11-1 0v-5a.5.5 0 01.5-.5zm3.5 0a.5.5 0 01.5.5v5a.5.5 0 11-1 0v-5a.5.5 0 01.5-.5z",
    fill: "#FF2A2A"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableDelete);
export default __webpack_public_path__ + "static/assets/table-delete.bb9d8331.svg";
export { ForwardRef as ReactComponent };